export default __webpack_public_path__ + "edca222f6295d7fed1e5dd5f03dece3c.png";